{
  "colorFormat": "색상 형식",
  "hex": "HEX",
  "hsb": "HSB",
  "hsl": "HSL",
  "rgb": "RGB"
}
